export default "__VITE_ASSET__b0160ff5__"